/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterPrefixGetActiveGet } from '../fn/prefix/api-master-prefix-get-active-get';
import { ApiMasterPrefixGetActiveGet$Params } from '../fn/prefix/api-master-prefix-get-active-get';
import { Prefix } from '../models/prefix';

@Injectable({ providedIn: 'root' })
export class PrefixService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterPrefixGetActiveGet()` */
  static readonly ApiMasterPrefixGetActiveGetPath = '/api/Master/Prefix/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPrefixGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPrefixGetActiveGet$Response(params?: ApiMasterPrefixGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Prefix>>> {
    return apiMasterPrefixGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPrefixGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPrefixGetActiveGet(params?: ApiMasterPrefixGetActiveGet$Params, context?: HttpContext): Observable<Array<Prefix>> {
    return this.apiMasterPrefixGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Prefix>>): Array<Prefix> => r.body)
    );
  }

}
